module.exports = __webpack_public_path__ + "static/4.1_early_empires-68efcf653c7a271b6618286597e0a1d3.pdf";